import { use, useState } from 'react';

import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';

type ResidentSettingDetailsInformationAccordion = {
  shouldShowInformation: boolean;
  shouldShowInformationNote: string | boolean;
  toggleShouldShowInformation: () => void;
};

const useResidentSettingDetailsInformationAccordion = (): ResidentSettingDetailsInformationAccordion => {
  const {
    detailEditState: { currentResidentSetting, viewingMode },
  } = use(ResidentSettingsProviderContext);

  const [shouldShowInformation, setShouldShowInformation] = useState<boolean>(false);

  const toggleShouldShowInformation = () => setShouldShowInformation(!shouldShowInformation);

  const shouldShowInformationNote = currentResidentSetting?.note || viewingMode !== 'viewing';

  return {
    shouldShowInformation,
    shouldShowInformationNote,
    toggleShouldShowInformation,
  };
};

export default useResidentSettingDetailsInformationAccordion;
